import { Flex } from 'foundations-components/components/Flex';
import { AddIcon } from 'foundations-assets';
import { usePinnedViewLimit } from '../../viewLimits/hooks/usePinnedViewLimit';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledSpan = styled.span.withConfig({
  displayName: "AddViewButton__StyledSpan",
  componentId: "ctbar9-0"
})(["margin:0 8px 0 0;"]);
export const AddViewButton = ({
  numberOfPinnedViews
}) => {
  const {
    data: pinnedViewsLimitData
  } = usePinnedViewLimit();
  const total = numberOfPinnedViews === undefined ? '--' : numberOfPinnedViews;
  const limit = pinnedViewsLimitData && pinnedViewsLimitData.toString() || '--';
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(AddIcon, {}), /*#__PURE__*/_jsx(StyledSpan, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        className: "m-left-2",
        message: "viewsManagement.pinnedViews.addView",
        options: {
          total,
          limit
        }
      })
    })]
  });
};